import React, { useRef , useState} from "react";
import Frame from "./Frame";
import {Box, useTheme, Typography,Button, ButtonBase} from "@mui/material";
import { tokens } from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { selectImageString } from "../../slices/sign_image_editor"

const ImageData = (props) =>  {

  const {} = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const imageString = useSelector(selectImageString);

  return (

        <Box
            display = "flex"
            justifyContent="flex-start"
            flexDirection="column"
            width = "100%"
            backgroundColor={colors.primary[300]} 
            sx={{border: `1px solid ${theme.palette.primary.main}` , borderRadius:2}}
            p="1rem"
        >
          <Typography variant="h3" align="left"
          >
            Image String
          </Typography>

          <Typography
            sx={{overflowWrap: "break-word"}}
          >
            {imageString}
          </Typography>

        </Box>

  );
}

export default ImageData;